module.exports = __webpack_public_path__ + "assets/3a6bbb6f94a6f555f5adee8819860dd3.png";